import { IconButton, Stack } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ChannelList from './Sidebar/SpaceList';
import ChannelView from './Channel/ChannelView';
import AiAssistantView from './AiAssistantView';
import { useChatNavigation } from './useChatNavigation';
import { APPBAR_HEIGHT } from '../../layout/dashboard-navigation/NavigationDashboard';
import { ReactComponent as XIcon } from '../../assets/icons/chat-icons/x.svg';

const ChatScreen = () => {
  const chatNavigation = useChatNavigation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const showAiAssistant = searchParams.get('showAiAssistant') === 'true';

  const handleClose = () => {
    navigate('/dashboard');
  };

  return (
    <Stack
      direction="row"
      height={`calc(100vh - ${APPBAR_HEIGHT}px)`}
      overflow={'hidden'}
      position={'relative'}
    >
      <ChannelList />
      {showAiAssistant ? (
        <AiAssistantView />
      ) : (
        chatNavigation.currentChannelId && (
          <ChannelView
            key={chatNavigation.currentChannelId}
            channelId={chatNavigation.currentChannelId}
          />
        )
      )}

      {/* Close Button */}
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          zIndex: 10,
          backgroundColor: '#fff',
          border: '1px solid',
          borderColor: 'secondaryBlue.200',
          '&:hover': {
            backgroundColor: 'secondaryBlue.50',
          },
        }}
      >
        <XIcon width={20} height={20} />
      </IconButton>
    </Stack>
  );
};

export default ChatScreen;
